export const IMAGES = {
  portada: 'https://cdn.magicpatterns.com/uploads/kTvdCaho6vrzBeh6VWVe8L/ARTE_EN_FILIGRANA.png',
  botanica: 'https://cdn.magicpatterns.com/uploads/8DCaoFGALRBG5fUdgnsX4m/FILIGRANA_BOTANICA.png',
  mandalas: 'https://cdn.magicpatterns.com/uploads/1cBbvd9M1JxvYFvZFg4jVy/FILIGRANA_MANDALAS.png',
  animales: 'https://cdn.magicpatterns.com/uploads/myVCqWe3aQLKhQuMScvBbb/FILIGRANA_ANIMALES.png',
  ocasiones:
    'https://cdn.magicpatterns.com/uploads/296shREcgPFCPumt6DP31h/FILIGRANA_PARA_OCASIONES.png',
  bonusAbc: 'https://cdn.magicpatterns.com/uploads/mZV34TBd5XQfWjRJmokbQM/BONUS_ABC.png',
  bonusEmprende:
    'https://cdn.magicpatterns.com/uploads/evBBjyHkBmXDZL7ycxBpTD/BONUS_EMPRENDE.png',
  bonusInspiracion:
    'https://cdn.magicpatterns.com/uploads/aqohbC6hjnq7A5fnLUEFzX/BONUS_BIBLIOTECA_INSPIRACION.png',
  flores: 'https://cdn.magicpatterns.com/uploads/eytvFZeWtKftgojTcBvG2G/REGALOS.jpg',
  floresAlt: 'https://cdn.magicpatterns.com/uploads/qiP96brvvtzvKSVPDw6Q3m/REGALOS.jpg',
  recuerdos: 'https://cdn.magicpatterns.com/uploads/3c616pediwx3ALs7xYF3A1/RECUERDOS.jpg',
  ocasionesFoto:
    'https://cdn.magicpatterns.com/uploads/vG9up6SkNzezUj8953cecW/OCASIONES_ESPECIALES.jpg',
  iniciales: 'https://cdn.magicpatterns.com/uploads/hFaZ1UMNJmrMEBWVHd9UCq/INICIALES.jpg',
  cuadros: 'https://cdn.magicpatterns.com/uploads/2YqH7RMCHhLRND5P3sb8Jq/CUADROS.jpg',
  tarjetas: 'https://cdn.magicpatterns.com/uploads/4NuaL9LsGkLTxVpcJYLRZR/TARJETAS.jpg',
  clasesGrabadas: 'https://cdn.magicpatterns.com/uploads/5cmsoauGJUUtW5sfTMXCgV/CLASES_GRABADAS.png',
  testimonio1: 'https://cdn.magicpatterns.com/uploads/beSxvxgQtDsG7yfgmD6SjF/image.png',
  testimonio2: 'https://cdn.magicpatterns.com/uploads/a3jCZ3qG4DaGLdknFhJp5e/image.png',
  testimonio3: 'https://cdn.magicpatterns.com/uploads/bvHTwVrGkXzuYp69QAxGy1/image.png',
  testimonio4: 'https://cdn.magicpatterns.com/uploads/fSnHkW6rjyQsxivptTaiT5/image.png',
  testimonio5: 'https://cdn.magicpatterns.com/uploads/o9hhnksfQei1dS6MqLPnDE/image.png',
  testimonio6: 'https://cdn.magicpatterns.com/uploads/eq2YiXSAhfc4ma85z2z6QU/image.png',
}

/** Video vertical del proceso de filigrana. Al cargarlo aquí reemplaza a la imagen de la sección. */
export const VIDEO_URL = 'https://cdn.magicpatterns.com/uploads/9kDEmDqp1wuj4jVv9MMUHh/WhatsApp Video 2026-08-16 at 14.12.23.mp4'

export const CHECKOUT_URLS = {
  AR: 'https://deco-emprende.impultienda.ar/checkout/el-arte-de-la-filigrana',
  INTL: 'https://deco-emprende.impultienda.ar/checkout/el-arte-de-la-filigrana',
}

export const PRICES = {
  AR: { current: 'ARS $24.990', previous: 'ARS $49.990' },
  INTL: { current: 'USD 14.99', previous: 'USD 29.99' },
}

export const heroBenefits = [
  'Ideal para principiantes',
  'Clases grabadas paso a paso',
  'Biblioteca con +150 plantillas',
  'Acceso inmediato y para siempre',
]

export const creationTypes = [
  { label: 'Tarjetas', img: IMAGES.tarjetas },
  { label: 'Cuadros', img: IMAGES.cuadros },
  { label: 'Recuerdos', img: IMAGES.recuerdos },
  { label: 'Iniciales', img: IMAGES.iniciales },
]

export const galleryItems = [
  { label: 'Flores', img: IMAGES.flores },
  { label: 'Letras y nombres', img: IMAGES.iniciales },
  { label: 'Cuadros', img: IMAGES.cuadros },
  { label: 'Tarjetas', img: IMAGES.tarjetas },
  { label: 'Ocasiones especiales', img: IMAGES.ocasionesFoto },
  { label: 'Recuerdos', img: IMAGES.recuerdos },
]

export const templateCategories = [
  {
    label: 'Filigrana botánica',
    desc: 'Flores, hojas y composiciones naturales.',
    img: IMAGES.botanica,
  },
  {
    label: 'Mandalas',
    desc: 'Diseños geométricos y decorativos.',
    img: IMAGES.mandalas,
  },
  {
    label: 'Animales',
    desc: 'Plantillas para cuadros y decoraciones.',
    img: IMAGES.animales,
  },
  {
    label: 'Ocasiones especiales',
    desc: 'Diseños para regalar y celebrar.',
    img: IMAGES.ocasiones,
  },
]

export const bonuses = [
  {
    tag: 'Bonus 1',
    title: 'Abecedario completo en filigrana',
    desc: 'Plantillas de todas las letras para crear nombres, iniciales, cuadros y regalos personalizados.',
    img: IMAGES.bonusAbc,
  },
  {
    tag: 'Bonus 2',
    title: 'Guía Emprende con Filigrana',
    desc: 'Una guía complementaria para quienes quieran explorar la posibilidad de convertir esta actividad creativa en una fuente adicional de ingresos.',
    img: IMAGES.bonusEmprende,
  },
  {
    tag: 'Bonus 3',
    title: '+100 ideas para inspirarte',
    desc: 'Una biblioteca visual con más de 100 ideas para descubrir nuevas posibilidades y encontrar inspiración para tus próximos proyectos.',
    img: IMAGES.bonusInspiracion,
  },
]

export const testimonials = [
  {
    name: 'Mariana R.',
    country: 'Argentina',
    text: 'Siempre veía trabajos de filigrana en internet y pensaba que eran demasiado difíciles. Empecé con las formas más sencillas y después hice estas flores. Todavía estoy practicando, pero me encantó el resultado.',
    img: IMAGES.testimonio1,
  },
  {
    name: 'Claudia M.',
    country: 'México',
    text: 'Las clases me ayudaron muchísimo porque necesitaba ver cómo se hacía cada movimiento. Ya terminé varias tarjetas y ahora quiero intentar un cuadro.',
    img: IMAGES.testimonio2,
  },
  {
    name: 'Patricia G.',
    country: 'Chile',
    text: 'Es una técnica muy relajante y las tarjetas quedan hermosas.',
    img: IMAGES.testimonio3,
  },
  {
    name: 'Marcela P.',
    country: 'Colombia',
    text: 'Las plantillas me parecieron muy prácticas porque no soy buena dibujando.',
    img: IMAGES.testimonio4,
  },
  {
    name: 'Rosa L.',
    country: 'Perú',
    text: 'Empecé buscando una actividad para hacer en mis ratos libres y terminé encantada. Me ayuda mucho a desconectarme y cada vez quiero probar diseños más grandes.',
    img: IMAGES.testimonio5,
  },
  {
    name: 'Verónica S.',
    country: 'Uruguay',
    text: 'Pensé que iba a ser mucho más difícil. Me encantó.',
    img: IMAGES.testimonio6,
  },
]

export const purchaseIncludes = [
  'Curso digital completo',
  'Guía paso a paso',
  'Clases grabadas',
  '+150 plantillas',
  'Abecedario completo',
  'Guía Emprende con Filigrana',
  '+100 ideas de inspiración',
  'Acceso inmediato y para siempre',
]

export const faqs = [
  {
    q: '¿Necesito experiencia previa?',
    a: 'No. El curso comienza desde los fundamentos y está pensado especialmente para personas que quieren aprender desde cero.',
  },
  {
    q: '¿Qué materiales necesito?',
    a: 'Los materiales principales son sencillos: papel, adhesivo y algunas herramientas básicas de filigrana. Dentro del curso conocerás qué necesitas y qué alternativas puedes utilizar.',
  },
  {
    q: '¿Es un producto físico?',
    a: 'No. El Arte de la Filigrana es un curso 100% digital. No se envía ningún producto físico.',
  },
  {
    q: '¿Cómo recibo el curso?',
    a: 'Después de completar tu compra recibirás las instrucciones para acceder al contenido digital.',
  },
  {
    q: '¿Las clases son en vivo?',
    a: 'No. Las clases son grabadas para que puedas verlas cuando quieras y repetirlas todas las veces que necesites.',
  },
  {
    q: '¿Tengo que pagar todos los meses?',
    a: 'No. Es un único pago.',
  },
]
